module.exports = __webpack_public_path__ + "img/1493633223.14717634.jpg";